import React from 'react';

export const formatDateForDisplay = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toISOString().split('T')[0];
};

export const renderReminderTracking = (oneMonthSent, fifteenDaySent) => (
  <div className="flex gap-4 mt-2 pt-2 border-t border-gray-100 dark:border-neutral-700/50">
    <div className="flex items-center gap-1.5">
      <div className={`w-1.5 h-1.5 rounded-full ${oneMonthSent ? 'bg-green-500' : 'bg-gray-300 dark:bg-neutral-600'}`} />
      <span className={`text-[9px] font-bold uppercase tracking-wider ${oneMonthSent ? 'text-green-600 dark:text-green-400' : 'text-gray-400'}`}>1-Month</span>
    </div>
    <div className="flex items-center gap-1.5">
      <div className={`w-1.5 h-1.5 rounded-full ${fifteenDaySent ? 'bg-green-500' : 'bg-gray-300 dark:bg-neutral-600'}`} />
      <span className={`text-[9px] font-bold uppercase tracking-wider ${fifteenDaySent ? 'text-green-600 dark:text-green-400' : 'text-gray-400'}`}>15-Day</span>
    </div>
  </div>
);

export const formSelectClass =
  'w-full px-3 py-2.5 text-sm bg-white dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-xl text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/25 focus:border-primary-500';

export const formInputClass =
  'w-full px-3 py-2.5 text-sm bg-white dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-xl text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/25';
